const WHATSAPP_LINK = 'https://wa.me/'

export const useWhatsappMessage = () => {
  const globalStore = useGlobalStore()
  const currentStore = useCurrentStore()
  const { event, metaEvent } = useEvent()
  const currency = currentStore?.currency
  const number = (globalStore.salespersonWhatsappNumber || '').replace(/\D/g, '')

  const send = (text: string, emitEvent = true) => {
    if (!number) {
      throw new Error('This store has no phone number configured')
    }

    const qs = new URLSearchParams({
      text,
    })

    window.open(`${WHATSAPP_LINK}${number}?${qs}`, '_blank')

    if (!emitEvent) return

    event('generate_lead', {
      currency,
      value: undefined,
    })

    metaEvent('Lead', MetaEventsPayloads.lead())
  }

  return {
    send,
  }
}
